module.exports = __webpack_public_path__ + "static/media/img_4.95efec19.png";